import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'valueOrDash',
})
export class ValueOrDashPipe implements PipeTransform {
  transform(value: unknown, fallback = '-'): unknown {
    if (value === null || value === undefined) {
      return fallback;
    }

    if (typeof value === 'string') {
      const trimmed = value.trim();
      return trimmed ? trimmed : fallback;
    }

    return value;
  }
}
